<template>
  <footer  class="clearfix mb-0"  v-if="expiredDate" >
        <p>
          <span>COPYRIGHT &copy;</span>
          <span>{{ new Date().getFullYear() }} </span>
          <a href="https://spore.cloud/" target="_blank" rel="nofollow">SPORE</a>
          <span class="sm:inline-block">, All rights Reserved</span>
        </p>
        <span class="md:flex items-center">
        </span>
    </footer>
</template>

<script>
export default {
  setup () {
    return {
      expiredDate: false
    }
  },
  created () {
    if ((this.$store.state.session.AppActiveUser().expirationDate) !== undefined) {
      this.expiredDate = true
    }
  }
}
</script>
